import { useSelectedEnvironmentKey } from '@gonfalon/app-context/useSelectedEnvironmentKey';
import { isExperimentApprovalsEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import { getEnvironmentQuery } from '@gonfalon/rest-api/queries/environments';
import { useProjectKey } from '@gonfalon/router/useProjectKey';
import { useSuspenseQuery } from '@tanstack/react-query';

/**
 * Checks if experiment approvals are required for the current environment.
 * Uses suspense to prevent flash of incorrect UI state.
 */
export function useExperimentApprovalsRequired(experimentTags: string[]): boolean {
  const projectKey = useProjectKey();
  const environmentKey = useSelectedEnvironmentKey();

  // Use suspense query to ensure environment data is loaded before rendering
  const { data: environment } = useSuspenseQuery(getEnvironmentQuery({ projectKey, environmentKey }));

  if (!isExperimentApprovalsEnabled()) {
    return false;
  }

  const approvalSettings = environment?.approvalSettings;
  if (!approvalSettings) {
    return false;
  }

  return approvalSettings.required || experimentTags.some((tag) => approvalSettings.requiredApprovalTags.includes(tag));
}
